import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { managerActions } from '@store/reducers/manager/actions'
import {
  GeneralErrorNotification,
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch, useSelector } from 'react-redux'

import Api from '@/api'

const changeReq = (
  id: ID,
  value: boolean,
  onError: () => void,
  onSuccess: () => void
) => Api.Projects.anonymousComments(id, value).then(onSuccess).catch(onError)

export const useAnonymousCommentsToggle = () => {
  const dispatch = useDispatch()
  const state = useSelector(migrationProjectSelector.getAnonymousComments)
  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const onClickBadge = () => {
    dispatch(
      openModal({
        modalType: MODAL_UPGRADE_PLAN,
        modalProps: {
          planType: 'pro',
          slideType: 'guest_comments',
        },
      })
    )
  }

  const onError = () => dispatch(GeneralErrorNotification)
  const onSuccess = () =>
    dispatch(
      notificationActionCreators.setNotification({
        type: NotificationType.ACCESS_SETTINGS_UPDATED,
      })
    )

  const onChange = (value: boolean) => {
    if (!projectId) {
      return
    }

    dispatch(managerActions.updateMeta({ anonymous_comments: value }))
    changeReq(projectId, value, onError, onSuccess)
  }

  return { state, onChange, onClickBadge }
}
